import { render } from "./base.html?vue&type=template&id=74c89c3c"
import script from "./Base.vue?vue&type=script&lang=ts"
export * from "./Base.vue?vue&type=script&lang=ts"
script.render = render

export default script